import React from 'react';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'githubSVG',
}) => {
  const hoverRef = React.createRef();
  const onHoverOn = e => {
    const hover = hoverRef.current;
    hover.classList.toggle('githubSVG_hover');
  };
  const onHoverOut = e => {
    const hover = hoverRef.current;
    hover.classList.toggle('githubSVG_hover');
  };
  return (
    <svg
      viewBox="0 0 288 267.5"
      height={height}
      width={width}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={onHoverOn}
      onMouseLeave={onHoverOut}
      ref={hoverRef}
    >
      <path
        d="M143,29C85.6,29,39,76.7,39,135.6c0,47.1,29.8,87.1,71.1,101.2c5.2,1,7.1-2.3,7.1-5.1c0-2.5-0.1-9.2-0.1-18.1
	c-28.9,6.4-35-14.3-35-14.3c-4.7-12.3-11.5-15.6-11.5-15.6c-9.4-6.6,0.7-6.5,0.7-6.5c10.4,0.8,15.9,11,15.9,11
	c9.3,16.3,24.3,11.6,30.3,8.9c0.9-6.9,3.6-11.6,6.6-14.3c-23.1-2.7-47.4-11.8-47.4-52.7c0-11.6,4.1-21.2,10.7-28.6
	c-1.1-2.7-4.6-13.5,1-28.2c0,0,8.7-2.9,28.6,10.9c8.3-2.4,17.2-3.5,26-3.6c8.8,0,17.7,1.2,26,3.6c19.9-13.8,28.6-10.9,28.6-10.9
	c5.7,14.7,2.1,25.5,1,28.2c6.7,7.5,10.7,17,10.7,28.6c0,41-24.3,50-47.5,52.6c3.7,3.3,7.1,9.8,7.1,19.7c0,14.3-0.1,25.8-0.1,29.3
	c0,2.9,1.9,6.2,7.2,5.1c41.3-14.1,71.1-54.1,71.1-101.2C247,76.7,200.4,29,143,29z"
      />
    </svg>
  );
};

export default SVG;
